import styled from "styled-components";
import Form from "../Components/Form";

export default function FaleConosco(){
    return(
        <Content>
            <Form/>
        </Content>
    )
}

const Content = styled.div`
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    margin: 0 auto;
`